import { IPostProduct } from './postProduct.model';
import { Category } from './category.model';
import { IProductCharacteristic } from './productCharacteristic.model';
import { ProductType } from './productType.model';
import { Shop } from './shop.model';
import {IProductProductSubType} from "./productProductSubType.model";
import {ISubProductCharacteristic} from "./subProductCharacteristic.model";
import { ITripExpenseProduct } from './tripExpenseProduct.model';
import { ProductDeliveryZones } from './productDeliveryZones.model';

export interface IProduct {
  id?: number;
  name?: string;
  productID?: string;
  photo?: string;
  shop?: Shop;
  product_type?: ProductType;
  category?: Category;
  available?: boolean;
  productCharacteristics?: IProductCharacteristic[];
  postProducts?: IPostProduct[];
  productProductSubTypes?: IProductProductSubType[];
  tripExpenseProducts?:ITripExpenseProduct[];
  productDeliveryZones ?: ProductDeliveryZones[];
  subProducts?: SubProduct[];
  photo1?: string;
  photo2?: string;
  photo3?: string;
  quantity?: number;
  price?: number;
  threshold?: number;
  deliveryDelay?: string;
  unitDeliveryDuration?: string;
  createdAt?: Date;

}

export interface SubProduct {
  id?: number;
  name?: string;
  subProductID?: string;
  photo?: string;
  photo1?: string;
  photo2?: string;
  productID ?: string;
  shop?: Shop;
  createdAt?: Date;
  product_type?: ProductType ;
  category?: Category;
  available?: boolean;
  subProductCharacteristics?: ISubProductCharacteristic[];
  quantity?: number;
  threshold?: number
}

export class Product implements IProduct {
  constructor(
    public id?: number,
    public name?: string,
    public productID?: string,
    public photo?: string,
    public shop?: Shop,
    public product_type?: ProductType,
    public category?: Category,
    public available?: boolean,
    public productCharacteristics?: IProductCharacteristic[],
    public postProducts?: IPostProduct[],
    public productProductSubTypes?: IProductProductSubType[],
    public tripExpenseProducts?:ITripExpenseProduct[],
    public productDeliveryZones?: ProductDeliveryZones[],
    public subProducts?: SubProduct[],
    public photo1?: string,
    public photo2?: string,
    public photo3?: string,
    public quantity?: number,
    public price?: number,
    public threshold?: number,
    public deliveryDelay?: string,
    public unitDeliveryDuration?: string,
    public createdAt ?: Date,
  ) {
    this.id = id;
    this.name = name;
    this.productID = productID;
    this.photo = photo;
    this.shop = shop;
    this.product_type = product_type;
    this.category = category;
    this.available = available;
    this.productCharacteristics = productCharacteristics;
    this.postProducts = postProducts;
    this.productProductSubTypes = productProductSubTypes;
    this.tripExpenseProducts=tripExpenseProducts;
    this.productDeliveryZones = productDeliveryZones;
    this.subProducts = subProducts;
    this.photo1 = photo1;
    this.photo2 = photo2;
    this.photo3 = photo3;
    this.quantity = quantity;
    this.price = price;
    this.threshold = threshold;
    this.deliveryDelay = deliveryDelay;
    this.unitDeliveryDuration = unitDeliveryDuration;
    this.createdAt = createdAt;
  }
}
